import type { MyHrCase } from '@/api/services/hrCases.service';

/** How a matter is named to the employee looking at it. */
export function caseTitle(hrCase: MyHrCase): string {
  if (hrCase.kind === 'discipline') return `Disciplinary matter · ${hrCase.typeLabel}`;
  // A respondent is not told who raised the grievance, or that it is one.
  if (hrCase.party === 'respondent') return 'HR matter';
  return `Your grievance · ${hrCase.typeLabel}`;
}
